export const dummyClientData = {
    logo: 'https://example.com/logo.png',
    companyName: 'Example Company',
    description: 'A fictional company with great products.',
  };
  